import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Button,
  Table,
  message,
  Form,
  Modal,
  Select,
  Spin,
  Space,
  Row,
  Col,
  Tooltip,
  Card,
  Typography,
  Input,
} from "antd";
import CustomModal from '../../components/common/CustomModal';
import { Link, useNavigate } from "react-router-dom";
import { MdAddHome } from "react-icons/md";
import {
  CarOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { AiFillAlert, AiFillDelete, AiFillEdit } from "react-icons/ai";
import {
  IoPersonSharp,
  IoReload,
  IoCheckmarkCircleSharp,
  IoAddCircle,
} from "react-icons/io5";
import { useTranslation } from "react-i18next";
import _ from "lodash";

export const Axios = axios.create({
  baseURL: process.env.REACT_APP_APPI_ADDRESS,
});
const { Option } = Select;

const TipoVehiculo = () => {
  if (sessionStorage.getItem("user_mod")) sessionStorage.removeItem("user_mod");

  const { t, i18n } = useTranslation();
  const [bottom, setBottom] = useState("bottomCenter");
  const [original, setOriginal] = useState([]);
  const [data, setData] = useState([]);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [spinning, setSpinning] = useState(false);
  const [spinTitle, setSpinTitle] = useState(t("global.loading"));
  const [messageApi, contextHolder] = message.useMessage();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading] = useState(false);
  const [searchValue, setSearchValue] = useState(""); // Estado para controlar el valor del input

  const headers = {
    accept: "*/*",
    Authorization: "Bearer " + sessionStorage.getItem("token"),
    "Content-Type": "application/json",
  };

  useEffect(() => {
    recargar();
  }, []);

  const filterData = (data) => (formatter) =>
    data.map((item) => ({
      text: formatter(item),
      value: formatter(item),
    }));

  const columns = [
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("vehicletype.denomination")}
        </p>
      ),
      dataIndex: "denominacion",
      width: 200,
      filterSearch: true,
      filters: _.uniqWith(
        filterData(data)((i) => i.denominacion),
        _.isEqual
      ),
      onFilter: (value, record) => record.denominacion.startsWith(value),
    },
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("vehicletype.active")}
        </p>
      ),
      dataIndex: "activo",
      // width: 200,
      render: (text) =>
        text === "1" ? (
          <IoCheckmarkCircleSharp size={20} color={"#0d6efd"} />
        ) : (
          <IoCheckmarkCircleSharp size={20} color={"red"} />
        ),
      // filterSearch: true,
      // filters: _.uniqWith(filterData(data)(i => i.activo), _.isEqual),
      // onFilter: (value, record) => record.activo.startsWith( value ),
    },
  ];

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: data.length, // Asegúrate de tener el total de elementos aquí
  });

  const handleTableChange = (newPagination) => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    });
  };

  const recargar = () => {
    //limpiar la busqueda del componente Search
    setSearchValue("");

    setSpinTitle(t("global.loading"));
    setSpinning(true);
    setSelectedRowKeys([]);
    let aux = [];

    // let start = 0;
    // let limit = 1000;

    Axios.post(
      "sd/getTipoVehiculo",
      {
        // "start": start,
        // "limit": limit,
        // "filtro":{
        //     "idrol": 1
        // }
      },
      {
        headers: headers,
      }
    )
      .then((response) => {
        setSpinning(false);
        if (response.data.data.length > 0) {
          for (let i = 0; i < response.data.data.length; i++) {
            aux.push({
              key: response.data.data[i].idtipovehiculo,
              idtipovehiculo: response.data.data[i].idtipovehiculo,
              denominacion: response.data.data[i].denominacion,
              activo: response.data.data[i].activo,
            });
          }
        }

        setData(aux);
        setOriginal(aux);
      })
      .catch((error) => {
        setSpinning(false);
      });
  };

  const getInfoForm = async (id) => {
    for (let i = 0; i < data.length; i++) {
      if (data[i].idtipovehiculo === id) {
        return data[i];
      }
    }
    return [];
  };

  const modificar = async () => {
    form.resetFields();
    const row = await getInfoForm(selectedRowKeys[0]);
    sessionStorage.setItem("user_mod", JSON.stringify(row));
  };

  const eliminar = (e) => {
    Modal.confirm({
      title: null,
      cancelText: "Cancelar",
      okText: "Aceptar",
      okType: "primary",
      content: (
        <div>
          <div style={{
            background: 'linear-gradient(135deg, #ff4d4f 0%, #ff7875 100%)',
            borderRadius: '12px 12px 0 0',
            padding: '24px',
            color: 'white',
            textAlign: 'center',
            marginBottom: '20px'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '16px'
            }}>
              <div style={{
                background: 'rgba(255,255,255,0.2)',
                borderRadius: '50%',
                width: '48px',
                height: '48px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '20px'
              }}>
                <AiFillAlert />
              </div>
              <div>
                <Typography.Title level={3} style={{
                  color: 'white',
                  margin: 0,
                  fontSize: '20px'
                }}>
                  Eliminar datos!
                </Typography.Title>
              </div>
            </div>
          </div>
          <div style={{ padding: '0 24px' }}>
            <span>{t("vehicletype.delete_data")}</span>
          </div>
        </div>
      ),
      onOk() {
        setSpinTitle(t("global.processing_data"));
        setSpinning(true);
        Axios.delete("sd/deleteTipoVehiculo", {
          data: {
            idtipovehiculo: selectedRowKeys,
          },
          headers: headers,
        })
          .then((response) => {
            setSpinning(false);
            if (response.data.success) {
              messageApi.open({
                type: "success",
                content: response.data.message,
                duration: 0,
              });

              setTimeout(messageApi.destroy, 2500);
              recargar();
            } else {
              messageApi.open({
                type: "error",
                content: t("info.error"),
                duration: 0,
              });

              setTimeout(messageApi.destroy, 2500);
            }
          })
          .catch((error) => {
            setSpinning(false);
            messageApi.open({
              type: "error",
              content: t("info.error"),
              duration: 0,
            });

            setTimeout(messageApi.destroy, 2500);
          });
      },
    });
  };

  const onSearch = (value, _e, info) => {
    filterLocal(value);
  };

  const filterLocal = (value) => {
    if (value === "" || value === null) {
      setData(original);
    } else {
      let aux = [];
      original.forEach(function (option) {
        if (
          option.denominacion.toUpperCase().indexOf(value.toUpperCase()) !== -1
        ) {
          aux.push(option);
        }
      });
      setData(aux);
    }
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const hasSelected = selectedRowKeys.length > 0;

  const selectRowUpdate = async (record) => {
    setSelectedRowKeys([record.key]);
    form.resetFields();
    let row = [];
    for (let i = 0; i < data.length; i++) {
      if (data[i].idtipovehiculo === record.key) {
        row = data[i];
      }
    }

    sessionStorage.setItem("user_mod", JSON.stringify(row));
    navigate(`/editTipoVehiculo/${record.key}`);
  };

  function activacion(e, activar) {
    Modal.confirm({
      title: null,
      cancelText: "Cancelar",
      okText: "Aceptar",
      okType: "primary",
      content: (
        <div>
          <div style={{
            background: activar
              ? 'linear-gradient(135deg, #27ae60 0%, #2ecc71 100%)'
              : 'linear-gradient(135deg, #e67e22 0%, #f39c12 100%)',
            borderRadius: '12px 12px 0 0',
            padding: '24px',
            color: 'white',
            textAlign: 'center',
            marginBottom: '20px'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '16px'
            }}>
              <div style={{
                background: 'rgba(255,255,255,0.2)',
                borderRadius: '50%',
                width: '48px',
                height: '48px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '20px'
              }}>
                {activar ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
              </div>
              <div>
                <Typography.Title level={3} style={{
                  color: 'white',
                  margin: 0,
                  fontSize: '20px'
                }}>
                  {activar ? "Activar vehículo" : "Desactivar vehículo"}
                </Typography.Title>
              </div>
            </div>
          </div>
          <div style={{ padding: '0 24px' }}>
            <span>
              ¿Desea {activar ? "activar" : "desactivar"} el vehículo
              seleccionado?
            </span>
          </div>
        </div>
      ),
      onOk() {
        setSpinTitle(
          activar ? "Activando vehículo..." : "Desactivando vehículo..."
        );
        setSpinning(true);
        Axios.post(
          "sd/activarDesactivarTipoVehiculo",
          {
            idtipovehiculo: selectedRowKeys[0],
            activo: activar ? 1 : 0,
          },
          {
            headers: headers,
          }
        )
          .then((response) => {
            setSpinning(false);
            if (response.data.success) {
              messageApi.open({
                type: "success",
                content: activar
                  ? "Vehículo activado satisfactoriamente"
                  : "Vehículo desactivado satisfactoriamente",
                duration: 0,
              });

              setTimeout(messageApi.destroy, 2500);
              recargar();
            } else {
              messageApi.open({
                type: "error",
                content: activar
                  ? "Error activando Vehículo"
                  : "Error desactivando Vehículo",
                duration: 0,
              });

              setTimeout(messageApi.destroy, 2500);
            }
          })
          .catch((error) => {
            setSpinning(false);
            messageApi.open({
              type: "error",
              content: activar
                ? "Error activando Vehículo"
                : "Error desactivando Vehículo",
              duration: 0,
            });

            setTimeout(messageApi.destroy, 2500);
          });
      },
    });
  }

  return (
    <div style={{
      minHeight: "100vh",
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      padding: "16px"
    }}>
      <Spin spinning={spinning} tip={spinTitle} size="large">
        {/* Header Principal */}
        <div style={{
          background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
          borderRadius: '8px',
          padding: '12px',
          marginBottom: '12px',
          color: 'white',
          boxShadow: '0 2px 8px rgba(37, 50, 137, 0.3)'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px'
          }}>
            <div style={{
              background: 'rgba(255,255,255,0.2)',
              borderRadius: '50%',
              width: '24px',
              height: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '12px'
            }}>
              <CarOutlined />
            </div>
            <div style={{ flex: 1 }}>
              <Typography.Title level={4} style={{
                color: 'white',
                margin: 0,
                fontSize: '16px'
              }}>
                {t("vehicletype.title")}
              </Typography.Title>
              <Typography.Text style={{
                color: 'rgba(255,255,255,0.8)',
                margin: 0,
                fontSize: '12px'
              }}>
                Gestión de tipos de vehículos • {data.length} tipos
              </Typography.Text>
            </div>
            <div style={{
              background: 'rgba(255,255,255,0.2)',
              borderRadius: '8px',
              padding: '8px 16px'
            }}>
              <Typography.Text style={{ color: 'white', margin: 0, fontSize: '14px', fontWeight: 'bold' }}>
                {data.length} tipos
              </Typography.Text>
            </div>
          </div>
        </div>

        {contextHolder}

        {/* Panel de Herramientas */}
        <Card
          style={{
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            border: 'none',
            marginBottom: '12px'
          }}
          styles={{ body: { padding: '12px' } }}
        >
          <Row justify="center" align="middle" gutter={[4, 4]}>
            <Col xs={24}>
              <Space wrap size="small" style={{ justifyContent: 'center', width: '100%' }}>
                <Link to="/addTipoVehiculo">
                  <Tooltip title={t("vehicletype.add")}>
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      disabled={loading}
                      size="small"
                      style={{
                        background: 'linear-gradient(135deg, #27ae60 0%, #2ecc71 100%)',
                        borderColor: '#27ae60',
                        borderRadius: '8px',
                        height: '32px',
                        fontWeight: '500',
                        boxShadow: '0 2px 8px rgba(39, 174, 96, 0.3)'
                      }}
                    >
                      {t("vehicletype.add")}
                    </Button>
                  </Tooltip>
                </Link>

                <Link to={`/editTipoVehiculo/${selectedRowKeys[0]}`}>
                  <Tooltip title={t("vehicletype.edit")}>
                    <Button
                      type="primary"
                      icon={<AiFillEdit />}
                      onClick={modificar}
                      disabled={loading || selectedRowKeys.length !== 1}
                      size="small"
                      style={{
                        background: hasSelected && selectedRowKeys.length === 1 && !loading
                          ? 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)'
                          : '#d9d9d9',
                        borderColor: hasSelected && selectedRowKeys.length === 1 && !loading
                          ? '#253289'
                          : '#d9d9d9',
                        borderRadius: '8px',
                        height: '32px',
                        fontWeight: '500',
                        color: hasSelected && selectedRowKeys.length === 1 && !loading
                          ? 'white'
                          : '#000000',
                        boxShadow: hasSelected && selectedRowKeys.length === 1 && !loading
                          ? '0 2px 8px rgba(37, 50, 137, 0.3)'
                          : 'none'
                      }}
                    >
                      {t("vehicletype.edit")}
                    </Button>
                  </Tooltip>
                </Link>

                <Tooltip title={t("vehicletype.activate")}>
                  <Button
                    type="primary"
                    icon={<CheckCircleOutlined />}
                    onClick={(e) => {
                      activacion(e, true);
                    }}
                    disabled={loading || selectedRowKeys.length !== 1}
                    size="small"
                    style={{
                      background: hasSelected && selectedRowKeys.length === 1 && !loading
                        ? 'linear-gradient(135deg, #27ae60 0%, #2ecc71 100%)'
                        : '#d9d9d9',
                      borderColor: hasSelected && selectedRowKeys.length === 1 && !loading
                        ? '#27ae60'
                        : '#d9d9d9',
                      borderRadius: '8px',
                      height: '32px',
                      fontWeight: '500',
                      color: hasSelected && selectedRowKeys.length === 1 && !loading
                        ? 'white'
                        : '#000000',
                      boxShadow: hasSelected && selectedRowKeys.length === 1 && !loading
                        ? '0 2px 8px rgba(39, 174, 96, 0.3)'
                        : 'none'
                    }}
                  >
                    {t("vehicletype.activate")}
                  </Button>
                </Tooltip>

                <Tooltip title={t("vehicletype.deactivate")}>
                  <Button
                    type="primary"
                    danger
                    icon={<CloseCircleOutlined />}
                    onClick={(e) => {
                      activacion(e, false);
                    }}
                    disabled={loading || selectedRowKeys.length !== 1}
                    size="small"
                    style={{
                      borderRadius: '8px',
                      height: '32px',
                      fontWeight: '500',
                      background: hasSelected && selectedRowKeys.length === 1 && !loading
                        ? '#ff4d4f'
                        : '#d9d9d9',
                      borderColor: hasSelected && selectedRowKeys.length === 1 && !loading
                        ? '#ff4d4f'
                        : '#d9d9d9',
                      color: hasSelected && selectedRowKeys.length === 1 && !loading
                        ? 'white'
                        : '#000000'
                    }}
                  >
                    {t("vehicletype.deactivate")}
                  </Button>
                </Tooltip>

                <Tooltip title={t("vehicletype.delete")}>
                  <Button
                    type="primary"
                    danger
                    icon={<AiFillDelete />}
                    onClick={eliminar}
                    disabled={!hasSelected || loading}
                    size="small"
                    style={{
                      borderRadius: '8px',
                      height: '32px',
                      fontWeight: '500',
                      background: hasSelected && !loading
                        ? '#ff4d4f'
                        : '#d9d9d9',
                      borderColor: hasSelected && !loading
                        ? '#ff4d4f'
                        : '#d9d9d9',
                      color: hasSelected && !loading
                        ? 'white'
                        : '#000000'
                    }}
                  >
                    {t("vehicletype.delete")}
                  </Button>
                </Tooltip>

                <Tooltip title={t("vehicletype.update")}>
                  <Button
                    type="primary"
                    icon={<IoReload />}
                    onClick={recargar}
                    loading={loading}
                    size="small"
                    style={{
                      background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                      borderColor: '#253289',
                      borderRadius: '8px',
                      height: '32px',
                      fontWeight: '500',
                      boxShadow: '0 2px 8px rgba(37, 50, 137, 0.3)'
                    }}
                  >
                    {t("vehicletype.update")}
                  </Button>
                </Tooltip>
              </Space>
            </Col>
          </Row>
        </Card>

        {/* Tabla de Tipos de Vehículo */}
        <Card
          style={{
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            border: 'none'
          }}
          styles={{ body: { padding: '0' } }}
          title={
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '12px 16px',
              borderBottom: '1px solid #f0f0f0'
            }}>
              <Typography.Title level={5} style={{ margin: 0, color: '#253289' }}>
                Lista de Tipos de Vehículo
              </Typography.Title>
              <Space>
                <Input.Search
                  placeholder={t("vehicletype.search")}
                  style={{ width: '120px' }}
                  size="small"
                  onSearch={onSearch}
                  value={searchValue}
                  onChange={(e) => {
                    setSearchValue(e.target.value);
                    filterLocal(e.target.value);
                  }}
                  allowClear
                />
              </Space>
            </div>
          }
        >
          <Table
            size="small"
            bordered={false}
            columns={columns}
            dataSource={data}
            rowSelection={rowSelection}
            onChange={handleTableChange}
            style={{
              background: 'white',
              borderRadius: '8px'
            }}
            pagination={{
              position: [bottom],
              current: pagination.current,
              pageSize: pagination.pageSize,
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "50", "100"],
              showTotal: (total) => `Total ${total} elementos`,
              style: {
                padding: '8px 12px',
                borderTop: '1px solid #f0f0f0'
              }
            }}
            onRow={(record) => {
              return {
                onDoubleClick: async () => {
                  // selectRowUpdate(record);
                },
              };
            }}
          />
        </Card>
      </Spin>
    </div>
  );
};
export default TipoVehiculo;
